<template lang="slm">
main
  header.Article-header
    .container
      .columns
        .column(style="background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAHElEQVQYV2N8buL2X/LMLkYGKIAzMARgKjFUAABX/QgF18z6NgAAAABJRU5ErkJggg==')")
          .Article-headerBackground
            h1
              |Bli
              br
              | medlem i Rød Ungdom!

  article.Article
    .container
      .columns.is-multiline
        .column.is-7-widescreen.is-offset-0-widescreen.is-10-tablet.is-offset-1-tablet
          form(action="/velkommen" id='stripe-form' name='innmelding' class='Form' novalidate netlify ref="memberForm")
            input type='hidden' name='form-name' value='innmelding'
            .control.is-grouped.Form-control
              p.control.Form-control.is-expanded
                label.label Fullt navn
                input(type='text' class='input is-large' :class="{'is-danger': errors.has('navn')}" name='navn' v-validate="'required'")
                span.form-error v-show="errors.has('navn')" Feltet må fylles ut

            .control.Form-control
              p.control.is-expanded.Form-control
                label.label Gateadresse
                input(type='text' class='input is-large' name='Gatenavn' v-validate="'required'"  :class="{'is-danger': errors.has('Gatenavn')}")
                span.form-error v-show="errors.has('Gatenavn')" Feltet må fylles ut

            .control.is-grouped.Form-control
              p.hidden
                label.label Bot field
                input name="bot-field"
              p.control.Form-control
                label.label Postnummer
                input(type='number' max='9999' class='input is-large' name='Postnummer' v-validate="'required'"  :class="{'is-danger': errors.has('Postnummer')}")
                span.form-error v-show="errors.has('Gatenavn')" Feltet må fylles ut

              p.control.is-expanded.Form-control
                label.label Poststed
                input(type='text' name='Poststed' class='input is-large' v-validate="'required'" :class="{'is-danger': errors.has('Poststed')}")
                span.form-error v-show="errors.has('Poststed')" Feltet må fylles ut

            .control.is-grouped.Form-control
              p.control.is-expanded.Form-control
                label.label(for='email') E-post
                input(type='email' name='Epost' id='email' class='input is-large' v-validate="'required|email'" :class="{'is-danger': errors.has('Epost')}")
                span.form-error v-show="errors.has('Epost')" {{errors.first('Epost')}}

              p.control.Form-control
                label.label Telefon
                input(type='tel' name='Telefon' class='input is-large' v-validate="'required'" :class="{'is-danger': errors.has('Telefon')}")
                span.form-error v-show="errors.has('Telefon')" Feltet må fylles ut

              p.control.Form-control
                label.label(for="dob" style="display: inline-block;")
                  | Fødselsdato
                span
                  small
                    | &nbsp; (dd.mm.åååå)
                input type="text" name="dob" class='input is-large'  v-validate="'required'" placeholder="dag.måned.år" :class="{'is-danger': errors.has('dob')}"
                span.form-error v-show="errors.has('dob')" Feltet må fylles ut

            p.control
              button.button.Button.is-primary.is-marginless.send-button type="button" @click="validateForm" :class="{'is-loading': isLoading}" Send

        .column.is-5-widescreen.is-offset-0-widescreen.is-10-tablet.is-offset-1-tablet.Infobox-container
          aside.InfoBox.has-padding
            .content
              h4 Hvor mye skal du betale?
              p
                | Kontingentsatsene er som følger:
                br
                | Førstegangskontingent: 50 kr.
                br
                | Ungdomsskoleelever/arbeidsløse: 100 kr.
                br
                | Videregåendeelever/studenter/vernepliktige: 200 kr.
                br
                | Arbeidende: 400 kr.

              h4 Hvordan betaler du?
              p
                | Du kan betale på tre ulike måter:
                br
                br
                | 1. Overføring i nettbank til kontonummer: 1645.13.32663. Det er denne måten vi liker best, fordi da får vi hele summen selv! Husk å merke betalingen med navn.
                // br
                // br
                // | 2. Sende sms til telefonnummer 2434 med teksten RU &#60;mellomrom&#62; beløpet du skal betale &#60;mellomrom&#62; navn . Eks: RU 200 Kari Nordmann (NB: Dersom du er arbeidende må du sende 2 SMS-er tilsvarende 200). Husk å merke betalingen med navn.
                br
                br
                | 2. Vipps: Trykk på "Kjøp noe" i appen, søk opp "Kontingent Rød Ungdom" eller 120248 og vipps kontingentsummen. Husk å merke betalingen med navn. OBS! Ikke bruk kontoen "Rød Ungdom", bruk "Kontingent Rød Ungdom".
                br
                br
                em
                  | Vi gjentar: Uansett hvilken metode du velger, så må du huske å merke betalingen med ditt navn!
</template>

<script>
import norwegian from 'vee-validate/dist/locale/nb_NO'
require('es6-promise').polyfill()
require('isomorphic-fetch')

export default {

  data () {
    return {
      isLoading: false
    }
  },
  metaInfo () {
    return {
      title: 'Rød Ungdom \u2014 Bli medlem!', // set a title
      htmlAttrs: {
        lang: 'no',
        amp: undefined // "amp" has no value
      },
      meta: [
        {name: 'title', content: 'Rød Ungdom \u2014 Bli medlem!'},
        {name: 'description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!'},
        {name: 'twitter:title', content: 'Rød Ungdom \u2014 Bli medlem!'},
        {name: 'twitter:description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!'},
        {name: 'twitter:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png'},
        {property: 'og:title', content: 'Rød Ungdom \u2014 Bli medlem!'},
        {property: 'og:description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!'},
        {property: 'og:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png'},
        {property: 'og:url', content: 'https://xn--rdungdom-54a.no' + this.$route.path}
      ]
    }
  },
  created () {
    this.$validator.localize('nb_NO', {
      messages: norwegian.messages
    })
    this.$validator.localize('nb_NO')
  },
  methods: {
    // For the form to get handled by Netlify, we need a seperate html-file with the form
    // this is located in /static/member-form.html
    validateForm () {
      this.isLoading = true
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.submitForm()
          } else {
            this.formIsValid = false
            this.isLoading = false
          }
        })
    },
    submitForm () {
      var data = new FormData(this.$refs.memberForm)
      fetch(this.$refs.memberForm.action, {
        body: data,
        method: 'POST'
      }).then((result) => {
        if (result.status === 200) {
          this.$router.push('/velkommen')
        }
      })
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/BecomeMember.vue